import React from 'react';

import './Button.css';

export const Button = (props) => {
  const type = props.type === undefined ? "button" : props.type;
  return (
    <button className={["button", props.className].join(' ')} type={type} onClick={props.onClick} disabled={props.disabled}>{props.children}</button>
  );
}
